export const role = {
  deleteInformation:
    "要删除角色“{0}”，请为列表中的用户指定新的角色，或者删除。",
  deleteNoUsedTip: "角色“{0}”将被删除。确定要继续吗？",
  deleteUsedTip: "确认删除角色{0}并应用更改？",
  deleteUser: "删除账号",
  deleteVideos: "删除视频",
  disabled: "未启用",
  download: "下载",
  downloadVideos: "下载视频",
  enabled: "已启用",
  failedToSaveRoleNameAlreadyExist: "保存失败，此角色已存在。",
  historyMustBeEnabled: "请先启用历史",
  newRole: "新建角色",
  pleaseInputRoleName: "请输入角色名称",
  roleDeletion: "删除角色",
  roleDetails: "角色详情",
  roleNameAlreadyExist: `角色“{0}”已存在`,
  selectRole: "请选择角色",
  uploadDriversFaceIDPhoto: "上传司机照片",
  uploadVideos: "上传视频",
  vehicleCalibrationRegistrationAndSettings: "系统注册",
  viewUploadVideos: "查看上传视频",
  video: "视频",
  workXConnectCloud: "CWorkX Connect 网页",
  workxConnectionApplet: "微信小程序",
  workxConnectionAppletServiceNotify: "移动端消息接收",
  vehicleRepair: "设备维修",
  vehicleMaintenance: "设备保养",
  editRole: "编辑角色",
  upload: "上传",
  downLoad: "下载",
  apply: "应用到",
  related: "关联",
  publicPermissionSetting: "公域权限设定",
  privatePermissionSetting: "私域权限设定",
  historyAlert: "事件信息/历史作业",
  messageReceive: "网页端消息接收",
};
